import { css, styled } from "@mui/material";
import { ROW_ALIGN_CENTER__SPACE_B } from "../../../styles/global-styles";
import { breakpoints } from "../../../styles/media-queries";

export const NavigationStyled = styled("nav")`
  ${ROW_ALIGN_CENTER__SPACE_B};
  -webkit-animation: slide-in-bottom 1.5s cubic-bezier(0.1, 0.8, 0.1, 1) both;
  animation: slide-in-bottom 1.5s cubic-bezier(0.1, 0.8, 0.1, 1) both;
  animation-delay: 200ms;
  @-webkit-keyframes slide-in-bottom {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes slide-in-bottom {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  /* The nav sizes to its content rather than to a hard-coded width, so adding
     or removing an item cannot push the logo and the CTA out of the header.
     The gap tightens in the 1151–1440 band, where the row is widest relative
     to the space it has; above 1440 it is the original 56px. */
  gap: 32px;
  flex: 0 1 auto;
  min-width: 0;
  @media (min-width: ${breakpoints.xxl}px) {
    gap: 56px;
  }
  @media (max-width: ${breakpoints.lg}px) {
    display: none;
  }
  transition: opacity 1s;
  * {
    ${(props) =>
      props.hoveredItem
        ? css`
            transition: opacity 0.6s;
            opacity: 0.5;
          `
        : css`
            transition: opacity 0.6s;
            opacity: 1;
          `}
  }
  & .nav-items {
    color: var(--River-bed);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    line-height: 130%;
    white-space: nowrap;
    margin: -10px -12px;
    padding: 10px 12px;
    :hover {
      opacity: 1;
      cursor: pointer;
    }
  }
`;
